export enum FinancialProvider {
  Student = 0,
  Supplier = 1
}
